import React from 'react'
import styled from 'styled-components'
import {_L, useLocaleState} from '../../context/LocaleContext'
import {useViewFetch} from '../../utils/fetch'
import {fetchRoomInfo} from '../../api/room'

const RoomInfo = ({room}) => {
  const {name, blId, flId, rmId, rmArrangeTypeId} = room
  const localeState = useLocaleState()

  // TODO: Use viewFetch and combine data fetch

  const {data} = useViewFetch({
    api: fetchRoomInfo,
    parameters: {blId, flId, rmId, rmArrangeTypeId},
    initialState: {
      amenities: [],
      minRequired: 0,
      maxCapacity: 0,
      photoUrl: null
    },
    onChangeOf: [blId, flId, rmId, rmArrangeTypeId]
  })

  const {amenities, minRequired, maxCapacity, photoUrl} = data

  const floor = `${_L({key: 'Floor', localeState})}  ${flId}`

  const rm_name = name
    ? `${rmId}  -  ${name}`
    : `${_L({key: 'Room', localeState})} ${rmId}`

  const seats = `${minRequired}  - ${maxCapacity}  ${_L({
    key: 'Seats',
    localeState
  })}`

  return (
    <Container>
      <RoomImage src={photoUrl} />
      <RoomContainer>
        <StyledName>{rm_name}</StyledName>
        <StyledFloorLabel>
          {floor}
          <StyledDot>&#183;</StyledDot>
          {seats}
        </StyledFloorLabel>
        <AmenitiesLabel>{_L({key: 'Amenities', localeState})}</AmenitiesLabel>
        <AmenitiesListContainer>
          {amenities.map((item,idx) => (
            <AmenityItem key={`${item.resourceStd}-${idx}`}>
              {item.name || item.resourceStd}
            </AmenityItem>
          ))}
        </AmenitiesListContainer>
      </RoomContainer>
    </Container>
  )
}

export default RoomInfo

const Container = styled.div`
  width: 540px;
  height: 100%;
  background-color: #ffffff;

  @media (max-width: 1024px) {
    width: 320px;
  }

  @media (max-width: 700px) {
    width: 100%;
  }
`

const StyledText = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  box-sizing: border-box;
  letter-spacing: -0.4px;
`
const RoomImage = styled.img`
  width: 100%;
  height: auto;
  box-sizing: border-box;
`

const RoomContainer = styled.div`
  padding: 36px 56px 36px 56px;

  @media (max-width: 1024px) {
    padding: 12px 16px 12px 16px;
  }
`

const StyledName = styled(StyledText)`
  font-size: 22px;
  padding-bottom: 6px;

  @media (max-width: 1024px) {
    font-size: 18px;
    font-weight: 700;
  }
`
const StyledFloorLabel = styled(StyledText)`
  font-size: 16px;
  color: #a4a9b7;
  font-weight: 600;
  padding-bottom: 10px;

  @media (max-width: 1024px) {
    font-size: 14px;
    padding-bottom: 5px;
  }
`

const StyledDot = styled.span`
  padding: 0 10px 0 10px;
`

const AmenitiesLabel = styled(StyledText)`
  font-size: 19px;
  font-weight: normal;
  letter-spacing: -0.26px;
  color: #a4a9b7;
  padding-top: 24px;
  padding-bottom: 6px;

  @media (max-width: 1024px) {
    font-size: 14px;
  }

  @media (max-width: 700px) {
    padding-top: 16px;
  }
`

const AmenitiesListContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  box-sizing: border-box;
`

const AmenityItem = styled(StyledText)`
  font-weight: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px 19px 7px 19px;
  border-radius: 17px;
  background-color: #f3f5fb;
  margin: 5px 10px 5px 0;

  @media (max-width: 1024px) {
    padding: 4px 14px 4px 14px;
    margin: 4px 8px 5px 0;
  }
`
